import { z } from "zod";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const quoationBlockSchema = z.object({
	quotation: nonEmptyString,
	authorName: nonEmptyString,
	authorTitle: nonEmptyString,
});
